import React, { useRef, useState } from 'react'
import { useOnClickOutside } from 'core/hooks/clickOutside'
import { classNames } from 'core/helpers/misc'
import { history } from 'core/helpers/history'
import { Button } from 'core/components/button'

export const ActionsList = ({ actions, entity, primaryKey, forceRefresh }) => {
	const ref = useRef(null)
	const [opened, setOpened] = useState(false)

	useOnClickOutside(ref, () => setOpened(false))

	return (
		<div
			className={classNames('dropdown table-drop', {
				show: opened,
			})}
			ref={ref}
		>
			<button
				className="btn btn-sm btn-clean btn-icon btn-icon-sm"
				data-toggle="dropdown"
				onClick={() => setOpened(true)}
				title="Ações"
				type="button"
			>
				<i className="fas fa-cog" />
			</button>
			<div
				className={classNames('dropdown-menu dropdown-menu-right', {
					show: opened,
				})}
			>
				{actions
					.filter(({ hideWhen = () => false }) => !hideWhen(entity))
					.map(a => (
						<Button
							className="dropdown-item"
							icon={a.icon}
							key={`${a.icon}-${a.title}`}
							onClick={() => {
								setOpened(false)

								if (typeof a.action === 'string') {
									history.push(a.action.replace(':id', `${entity[primaryKey]}`))
									return
								}

								a.action({ entity, forceRefresh })
							}}
							title={a.title}
						/>
					))}
			</div>
		</div>
	)
}
